<h2 mat-dialog-title>เกิดข้อผิดพลาด</h2>
<mat-dialog-content class="mat-typography">
  <p>
    {{ text }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Okay</button>
</mat-dialog-actions>
